<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-tabs v-model="activeTab" @tab-click="handleClick" v-if="!is_dialog">
                <el-tab-pane label="组卷日志" name="zj_log"></el-tab-pane>
                <el-tab-pane label="下载日志" name="down_log"></el-tab-pane>
                <el-tab-pane label="测试日志" name="test_log"></el-tab-pane>
                <!--<el-tab-pane label="作业日志" name="work_log"></el-tab-pane>-->
            </el-tabs>
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                <el-form-item label="客户名称" class="customer-input" v-if="!is_dialog">
                    <CustomerSelect ref="CustomerSelect" :customerIdss="searcherModel.school_id" v-model="searcherModel.school_id" @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <el-form-item label="学段/学科筛选">
                    <el-select size="small" v-model="searcherModel.xd" placeholder="请选择">
                        <el-option v-for="(item, key) in xd" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                    <el-select size="small" v-model="searcherModel.chid" placeholder="请选择">
                        <el-option v-for="(item, key) in subjects" :key="key" :label="item.subject_name"
                                   :value="item.subject_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间筛选">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.time"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="高级筛选">
                    <el-input placeholder="请输入内容" v-model="searcherModel.advance_filter_content"
                              class="input-with-select">
                        <el-select style="width: 110px" v-model="searcherModel.advance_filter_type" slot="prepend"
                                   placeholder="请选择">
                            <el-option v-for="(item, key) in advance_filters" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item v-if="activeTab!='work_log'" label="试卷来源">
                    <el-select v-model="searcherModel.paperfrom" placeholder="请选择">
                        <el-option v-for="(item, key) in paper_froms" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="重复下载项" prop="is_distinct">
                    <el-select v-model="searcherModel.is_distinct">
                        <el-option label="过滤" value="1"></el-option>
                        <el-option label="全部" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户类型" v-if="activeTab!='work_log'">
                    <el-select v-model="searcherModel.usertype" placeholder="请选择">
                        <el-option v-for="(item, key) in user_types" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="试题数大于" v-if="activeTab == 'down_log'">
                    <el-input size="small" type="number" v-model="searcherModel.questions_num"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch" icon="el-icon-search">搜索
                    </el-button>
                    <el-button size="small" @click="resetForm()">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <ExportFile 
                    url="/api/export/zujuan-log" 
                    :params="searcherModel" 
                    filename="组卷日志导出" 
                    buttonName="导出Excel(最多导出10000条)">
                    </ExportFile>
                    <el-button size="small" type="success" @click="dialogCountVisible=true;" v-if="customer_id > 0">在线生成报表</el-button>
                </el-form-item>
            </el-form>
            <!--组卷日志-->
            <div v-if="activeTab=='down_log'">共消耗<span style="color: red">{{coin_sum}}</span>个学币； <span
                    style="color: red">{{point_sum}}</span>个普通点
            </div>
            <el-table :data="list" v-if="activeTab!='work_log'" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list" :key="activeTab">
                <el-table-column label="ID" prop="id"></el-table-column>
                <el-table-column label="组卷ID" prop="pid"></el-table-column>
                <el-table-column label="试卷标题" prop="title"></el-table-column>
                <el-table-column label="学段学科">
                    <template slot-scope="scope">
                        {{xd[scope.row.xd]}}/
                        <span v-if="scope.row.chid" v-for="item in subjects">
                                <span v-if="item.subject_id == scope.row.chid ">
                                    {{item.subject_name}}
                                </span>
                            </span>
                    </template>
                </el-table-column>
                <el-table-column label="试卷来源">
                    <template slot-scope="scope">
                        {{paper_froms[scope.row.paperfrom]}}
                    </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="真实姓名" prop="real_name"></el-table-column>
                <el-table-column label="用户类型">
                    <template slot-scope="scope">
                        {{user_types[scope.row.usertype]}}
                    </template>
                </el-table-column>
                <el-table-column label="来源学校" prop="school_name"></el-table-column>
                <el-table-column v-if="activeTab=='test_log'" label="测试时间" prop="downtime"></el-table-column>
                <el-table-column v-if="activeTab=='zj_log' " label="组卷时间" prop="downtime"></el-table-column>
                <el-table-column v-if="activeTab=='down_log'" label="下载时间" prop="downtime"></el-table-column>
                <el-table-column label="下载IP" prop="ip">
                </el-table-column>
                <el-table-column v-if="activeTab=='down_log'" label="试题数" prop="questions_num"></el-table-column>
            </el-table>
            <!--作业日志-->
            <el-table v-else :data="list" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list" :key="activeTab">
                <el-table-column label="作业ID" prop="task_id"></el-table-column>
                <el-table-column label="作业标题" prop="title"></el-table-column>
                <el-table-column label="学段学科">
                    <template slot-scope="scope">
                        {{xd[scope.row.xd]}}/
                        <span v-if="scope.row.chid" v-for="item in subjects">
                                <span v-if="item.subject_id == scope.row.chid ">
                                {{item.subject_name}}
                                </span>
                            </span>
                    </template>
                </el-table-column>
                <el-table-column label="作业班级" prop="class_name"></el-table-column>
                <el-table-column label="布置老师" prop="username"></el-table-column>
                <el-table-column label="完成情况" prop="finish"></el-table-column>
                <el-table-column label="来源学校" prop="school_name"></el-table-column>
                <el-table-column label="组卷时间" prop="downtime"></el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            <ZjCountBar :params="searcherModel" v-if="dialogCountVisible" :dialogVisible="dialogCountVisible" @close="closeCountDialog"></ZjCountBar>
        </div>
    </div>
</template>

<script>
    import MyPagination from "~/widgets/MyPagination.vue";
    import Log from "~/services/log";
    import Params from "~/config/params";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import ZjCountBar from "~/views/log/dialog/ZjCountBar.vue";
    import moment from 'moment'

    export default {
        components: {
            MyPagination,
            CustomerSelect,
            ExportFile,
            ZjCountBar
        },

        props:{
            is_dialog:{
                required:false,
                type:Boolean
            },
            customer_id:{
                required:false,
            },
            active_name:{
                required:false,
            }
        },

        data() {
            return {
                activeTab: 'zj_log',
                xd: {
                    1: '小学',
                    2: '初中',
                    3: '高中',
                },
                advance_filters: {},
                common_advance_filters: {
                    0: '请选中',
                    1: '标题',
                    2: '试卷ID',
                    3: '用户名',
                    4: '来源学校',
                },
                work_advance_filters: {
                    0: '请选中',
                    1: '作业名称',
                    2: '作业ID',
                    3: '布置老师',
                    4: '来源学校',
                },
                paper_froms: {
                    0: '用户组卷',
                    1: '导题工具添加（管理员）',
                    2: '智能生成试卷',
                },
                user_types: {
                    0: '普通用户',
                    1: '学校用户',
                    2: 'VIP用户',
                },
                subjects: [],
                types: {
                    0: "普",
                    1: "精",
                    2: "特",
                    3: "资源包",
                },
                searcherModel: {
                    xd: '',
                    chid: '',
                    paperfrom: '',
                    usertype: '',
                    advance_filter_type: '',
                    advance_filter_content: '',
                    time: [
                        moment().startOf('year').format('YYYY-MM-DD'),
                        moment().format('YYYY-MM-DD')
                    ],
                    school_id: '',
                    is_distinct: '',
                    questions_num: '',
                },
                list: [],
                coin_sum: '',
                point_sum: '',
                loading: true,
                // 分页信息
                linkPage: null,
                dialogCountVisible: false,
            };
        },

        created() {
            this.activeTab = this.active_name ? this.active_name : 'zj_log';
            this.searcherModel.customer_id = this.customer_id ? this.customer_id : '';
            this.initData(this.searcherModel);
            this.advance_filters = this.common_advance_filters;
            this.subjects = Params.getSubjects();
        },

        methods: {

            down_count(params = {}) {
                Log.zj_down_count_point(params).then(res => {
                    this.coin_sum = res.data['coin_sum'];
                    this.point_sum = res.data['point_sum'];
                });
            },

            handleClick(tab) {
                if (this.activeTab == 'work_log') {
                    this.advance_filters = this.work_advance_filters;
                } else {
                    this.advance_filters = this.common_advance_filters;
                }
                this.resetForm();
            },

            initData(params = {}) {
                this.loading = true;
                params['log_type'] = this.activeTab
                let fetch = '';
                if (this.activeTab == 'zj_log') {
                    fetch = Log.zj_log(params);
                }
                if (this.activeTab == 'down_log') {
                    this.down_count(params);
                    fetch = Log.zj_down_log(params);
                }
                if (this.activeTab == 'work_log') {
                    fetch = Log.zj_work_log(params);
                }
                if (this.activeTab == 'test_log') {
                    fetch = Log.zj_test_log(params);
                }
                fetch.then(res => {
                    this.loading = false;
                    this.list = res.data;

                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },

            // 筛选查询
            submitSearch() {
                let params = _.clone(this.searcherModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.initData(this.searcherModel);
            },

            // 重置筛选表单
            resetForm() {
                this.searcherModel = _.clone(_.extend(this.searcherModel, {
                    ztcid: '',
                    username: '',
                    xueduanid: '',
                    xd: '',
                    chid: '',
                    advance_filter_content: '',
                    advance_filter_type: '',
                    paperfrom: '',
                    usertype: '',
                    pointtype: '',
                    time: [
                        moment().startOf('year').format('YYYY-MM-DD'),
                        moment().format('YYYY-MM-DD')
                    ],
                    school_id: '',
                    is_distinct: '',
                    questions_num: '',
                    customer_id: this.customer_id ? this.customer_id : ''
                }));
                this.list = [];
                this.initData(this.searcherModel);
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.school_id = object.label;
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                this.searcherModel['perPage'] = newSize;
                this.submitSearch();
            },

            handleCurrentChange(newPage) {
                // 处理当前页码变化事件
                this.searcherModel['page'] = newPage;
                this.submitSearch();
            },

            closeCountDialog(){
                this.dialogCountVisible = false;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/log/zj.vue